/** A page load coming back from the Auth0 login page: ?code|error=…&state=… */
export const isLoginCallback = (search: string) => {
  try {
    const params = new URLSearchParams(search)
    return params.has("state") && (params.has("code") || params.has("error"))
  } catch {
    return false
  }
}
